






















import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';

import Character from '@/types/Character';

import ImageSlider from '@/components/ImageSlider.vue';

import Util from '@/util/Util';

export default Vue.extend({
    name: 'Character',

    components: {
        ImageSlider
    },

    props: {
        characterId: {
            type: String,
            default: ''
        }
    },

    watch: {
        characterId(newCharacterId: string, oldCharacterId: Character) {
            Util.updateHeaders(this.getLanguage(this.characterById(newCharacterId).characterName), this.getLanguage(this.characterById(newCharacterId).characterDescription), this.characterById(newCharacterId).iconImage.url);
        }
    },

    created() {
        if (this.characterId) {
            Util.updateHeaders(this.getLanguage(this.characterById(this.characterId).characterName), this.getLanguage(this.characterById(this.characterId).characterDescription), this.characterById(this.characterId).iconImage.url);
        }
    },

    computed: {
		...mapState(['language']),

		...mapGetters(['characterById', 'isUserAdmin', 'getLanguage'])
    },

    methods: {
        editCharacter(): void {
            this.$router.push(`/${this.language}/admin/characters/${this.characterId}`);
        },

        splitByNewLine(text: string): string[] {
            return text ? text.split(/\r\n|\n|\r/) : [];
        }
    }
});
